import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Anexo } from '../models/anexo.model';
import { Page } from '../models/page.model';
import { CustoAdicional } from '../models/custo-adicional.model';

@Injectable({
    providedIn: 'root'
})
export class CustoAdicionalService extends BaseService<CustoAdicional> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/custoadicional`, injector);
    }

    getByEstimativaId(estimativaId: number): Observable<Page<CustoAdicional>> {
        return this.http.get<Page<CustoAdicional>>(`${environment.API_PRICE}/custoadicional/getByEstimativaId/${estimativaId}`);
    }
}
